var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingbag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 2.40002C9.34929 2.40002 7.20009 4.54922 7.20009 7.20002V8.40002H6.00009C5.38809 8.40002 4.8745 8.85964 4.8073 9.46804L3.6073 20.268C3.5701 20.6064 3.67809 20.946 3.90609 21.2004C4.13409 21.4548 4.45929 21.6 4.80009 21.6H19.2001C19.5409 21.6 19.8661 21.4548 20.0941 21.2004C20.3221 20.946 20.4301 20.6064 20.3929 20.268L19.1929 9.46804C19.1257 8.85964 18.6121 8.40002 18.0001 8.40002H16.8001V7.20002C16.8001 4.54922 14.6509 2.40002 12.0001 2.40002ZM14.4001 8.40002V7.20002C14.4001 5.87402 13.3261 4.80002 12.0001 4.80002C10.6741 4.80002 9.60009 5.87402 9.60009 7.20002V8.40002H14.4001ZM7.20009 12C7.20009 11.3376 7.73769 10.8 8.40009 10.8C9.06249 10.8 9.60009 11.3376 9.60009 12C9.60009 12.6624 9.06249 13.2 8.40009 13.2C7.73769 13.2 7.20009 12.6624 7.20009 12ZM15.6001 10.8C14.9377 10.8 14.4001 11.3376 14.4001 12C14.4001 12.6624 14.9377 13.2 15.6001 13.2C16.2625 13.2 16.8001 12.6624 16.8001 12C16.8001 11.3376 16.2625 10.8 15.6001 10.8Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingbag);
export default __webpack_public_path__ + "static/media/shoppingbag.f22835391cd8fe82b55488df28307344.svg";
export { ForwardRef as ReactComponent };